import { render } from "./WithdrawPage.vue?vue&type=template&id=6e1fabe9&scoped=true"
import script from "./WithdrawPage.vue?vue&type=script&lang=js"
export * from "./WithdrawPage.vue?vue&type=script&lang=js"

import "./WithdrawPage.vue?vue&type=style&index=0&id=6e1fabe9&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1fabe9"]])

export default __exports__